import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIIconButton from "@mui/material/IconButton";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid2";
import TileOrderStatusReason from "../../../Tile/TileOrderStatusReason";
import DialogSearchOrderStatusReason from "../../../Dialog/Search/DialogSearchOrderStatusReason";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminOrderStatusReasonDetailGeneral extends CardClass {
  constructor(props) {
    super(props);

    this.state.orderStatusReasonDialogOpen = false;
  }

  static contextType = MainContext; // For legacy class components
  /**
   * Render the content of the card.
   */
  renderContent() {
    let orderStatusReasonDetail = this.props.orderStatusReasonDetail;
    let orderStatusReason = null;

    const orderStatusReasonId =
      orderStatusReasonDetail && orderStatusReasonDetail.orderStatusReasonId;
    if (orderStatusReasonId) {
      orderStatusReason =
        this.context.orderStatusReasonsIndexed[orderStatusReasonId];
    }

    // Order Status Reason
    const handleEditOrderStatusReason = () => {
      this.setState({ orderStatusReasonDialogOpen: true });
    };
    const handleClearOrderStatusReason = () => {
      this.props.onChange({ orderStatusReasonId: null });
    };
    const orderStatusReasonIconButtons = [
      <MUIIconButton onClick={handleEditOrderStatusReason}>
        <MUIEditIcon />
      </MUIIconButton>,
    ];

    if (orderStatusReason) {
      orderStatusReasonIconButtons.push(
        <MUIIconButton onClick={handleClearOrderStatusReason}>
          <MUIDeleteIcon />
        </MUIIconButton>,
      );
    }

    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={
              this.props.orderStatusReasonDetail &&
              this.props.orderStatusReasonDetail.name
                ? this.props.orderStatusReasonDetail.name
                : ""
            }
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            onBlur={(e) => this.props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ name: e.target.value })}
            required={true}
            error={this.props.validationIssues.name ? true : false}
            helperText={
              this.props.validationIssues.name
                ? this.props.validationIssues.name
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={
              this.props.orderStatusReasonDetail &&
              this.props.orderStatusReasonDetail.description
                ? this.props.orderStatusReasonDetail.description
                : ""
            }
            size="small"
            label="Description"
            variant="standard"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({ description: e.target.value.trim() })
            }
            onChange={(e) =>
              this.props.onChange({ description: e.target.value })
            }
            error={this.props.validationIssues.description ? true : false}
            helperText={
              this.props.validationIssues.description
                ? this.props.validationIssues.description
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 1024,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <TileOrderStatusReason
            orderStatusReason={orderStatusReason}
            iconButtons={orderStatusReasonIconButtons}
            label="Order Status Reason"
            required={true}
            error={
              this.props.validationIssues.orderStatusReasonId ? true : false
            }
            helperText={
              this.props.validationIssues.orderStatusReasonId
                ? this.props.validationIssues.orderStatusReasonId
                : ""
            }
          />
        </MUIGrid>
        <DialogSearchOrderStatusReason
          open={this.state.orderStatusReasonDialogOpen}
          onClose={() => this.setState({ orderStatusReasonDialogOpen: false })}
          onSelect={(orderStatusReason) => {
            this.props.onChange({ orderStatusReasonId: orderStatusReason.id });
          }}
        />
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
